export class BackupZeroEtlStorageConfiguration {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlStorageConfiguration.attributeTypeMap;
    }
    constructor() {
    }
}
